<span class="dots-animation"><span></span><span></span><span></span></span>
<div class="am-flex-align am-flex-wrap gap-xxs">
  @if (typers?.length > 4) { <span>{{ typers?.length }} Teilnehmer</span> }
  @else { @for (typer of typers; track $index) {
    <span class="font-500">{{ typer }}{{ $index+2 < typers.length  ? ',' : '' }}</span>
    @if (typers?.length > 3 && typers.length-1 === $index+1) { <span>und</span> }
  }}
  <span>{{ typers.length > 1 ? 'tippen' : 'tippt' }}</span>
</div>
